import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ResetPassComponent } from './reset-pass/reset-pass.component';

const routes: Routes = [{
    path: '',
    component: HomeComponent,
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,      
      }, 
      {
        path: 'reset',
        component: ResetPassComponent,   
      }, 
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        // otherwise redirect to home
        path: '**',
        redirectTo: 'dashboard',      
      },
    ],
  }];


@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
  })
  export class HomeRoutingModule { }